import React from 'react'
import "./Heroimg2.css"

function Heroimg2() {
  return (
    <div className='hero-img'>
        <div className="heading">
            <h1>PROJECTS</h1>
            <p className='animation1'>Some of my recent works.</p>
        </div>
    </div>
  )
}

export default Heroimg2